import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router"
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { FuseConfigService } from '@fuse/services/config.service';
import {AuthService} from 'app/auth/auth.service';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
import { lang_login } from 'app/idiomas/i18n/login/login.lang';

@Component({
    selector     : 'mantenimiento',
    templateUrl  : './mantenimiento.component.html',
    styleUrls    : ['./mantenimiento.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class MantenimientoComponent
{

  // infoMantenimiento: any;
  textoAviso: string;

  constructor(
    private _fuseConfigService: FuseConfigService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _translateService: TranslateService,
    private authService: AuthService,
    private router: Router
  )
  {
    lang_login.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    this.colocaBackground();
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar   : {hidden: true },
        toolbar  : {hidden: true },
        footer   : {hidden: true },
        sidepanel: {hidden: true }
      }
    };

    let idiomaNavegador = navigator.language.split("-");
    let idiomaCGO: string;
    switch(idiomaNavegador[0]){
      case 'en': idiomaCGO = 'en'; break;
      case 'es': idiomaCGO = 'es'; break;
      case 'tr': idiomaCGO = 'tr'; break;
      case 'zh':
        switch (idiomaNavegador[1]) {
          case 'TW': idiomaCGO = 'zh1'; break;
          case 'CN': idiomaCGO = 'zh2'; break;
        }
      break;
      default: idiomaCGO = 'en';
    }
    this._translateService.use(idiomaCGO);

    //consulta el status de la plataforma, si está en mantenimiendo u operando
    this.authService.getMantenimiento().subscribe((respuesta:any) => {
      console.log(respuesta);

      if(respuesta.message == 'Success'){
        if(respuesta.status){
          console.log(respuesta.mensaje);
          console.log(this._translateService.currentLang);

          respuesta.mensaje.forEach((texto:any) => {
            console.log(texto.clave,'==',this._translateService.currentLang);

            if(texto.clave == this._translateService.currentLang){
              this.textoAviso = texto.mensaje;
            }
          });
        }
        else{
          this.router.navigate(['/login']);
        }
      }
    });
  }

  colocaBackground(){
    $(document).ready(function() {
      let i = 0;
      let images = [];
      for(let i=1;i<=3;i++){
        for(let j=1;j<=7;j++){
          images.push('assets/images/backgrounds/REG'+i+'/00'+j+'.jpg');
        }
      }
      //ordena las opciones segun el numero de orden que traen
      images.sort((a, b) => { return 0.5 - Math.random() });
      let image = $('#bgImg');

      image.css("background","url('./"+images [Math.floor((Math.random() * images.length) + 1)]+"') no-repeat");

      setInterval(function(){  
        image.fadeOut(1000, function () {
          image.css("background","url('./"+images [i++]+"') no-repeat");
          image.fadeIn(1000);
        });
        if(i == images.length)
        i = 0;
      }, 5000);           
    });
  }
}
